import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'smart-input-hint',
    templateUrl: './smart-input-hint.component.html',
    styleUrls: ['./smart-input-hint.component.scss'],
    standalone: false
})
export class SmartInputHintComponent implements OnInit {

  @Input() property: any;
  @Input() errorMessages: any;
  @Input() additionalClass: string;
  @Input() translationPrefix: string;
  @Input() keyName: string;
  @Input() hideDescription: boolean;

  constructor() {
  }

  ngOnInit() {
    if (this.additionalClass) {
      this.additionalClass = this.additionalClass.toLowerCase();
    }
  }

}
